<template>
  <div>
    <wc-page-title title='Financial Reports'>
      <template v-slot:rightSide>
        <wc-burger-menu>
          <v-list-item @click='showDatePickerDialog = true'>
            <v-list-item-icon>
              <v-icon color='info'>mdi-calendar</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Change Report Period</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click='handleExport' :disabled='!reports'>
            <v-list-item-icon>
              <v-icon color='success'>mdi-file-excel</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Export to Excel</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </wc-burger-menu>
      </template>
    </wc-page-title>
    <v-container>
      <report-title
      title='Profit and Loss'
      subtitle=''
    ></report-title>
    <v-simple-table dense>
      <tbody>
        <template v-for='(report_key, report_value) in this.reports'>
          <template v-if='report_value === "Revenue" || report_value === "Expense"'>
          <tr :key='report_value'>
            <td style='border-bottom: solid 1px;' class='pl-0' colspan='3'>
              <report-header :text='report_value'></report-header>
            </td>
          </tr>
            <template v-for='(accounts, index) in report_key'>
              <template v-for='(key, value) in accounts'>
                <template v-if='value === "Total Revenue" || value === "Total Expenses"'>
                  <tr :key='index + "_" + value + "_" + report_value' >
                    <td>
                      <span class='font-weight-bold text-uppercase'>
                        {{value}}
                      </span>
                    </td>
                    <td></td>
                    <td align="right" width="100">{{key | decMoney}}</td>
                  </tr>
                </template>
                <template v-else>
                  <template v-if='value == "Group Total"'>
                    <tr :key='index + "_" + value + "_" + report_value' >
                      <td style='padding-left: 35px;'>
                        <span class='font-weight-bold text-uppercase'> 
                          {{value}}
                        </span>
                      </td>
                      <td><span></span></td>
                      <td>
                        <span class='font-weight-bold text-uppercase'> 
                          {{key | decMoney}}
                        </span>
                      </td>
                    </tr>
                  </template>
                  <template v-else>
                    <tr :key='index + "_" + value + "_" + report_value'>
                      <td>
                        <span class='font-weight-bold text-uppercase'> 
                          {{value}}
                        </span>
                      </td>
                      <td><span></span></td>
                      <td></td>
                    </tr>
                    <template v-for='(account, i) in key'>
                      <tr :key='i + "_" + value + "_" + account.name' @click='lineClick(account)' style="cursor: pointer;">
                      <td style='padding-left: 35px;'>
                        <span> 
                          {{account.name}}
                        </span>
                      </td>
                      <td align="right" width="100">
                        <span>
                          {{account.value | decMoney}}
                        </span>
                      </td>
                      <td></td>
                    </tr>
                    </template>
                  </template>
                </template>
              </template>
              
            </template>
          </template>
          <template v-else>
            <tr :key='report_value'>
              <td>
              <report-header :text='report_value'></report-header>
              </td>
              <td>
              </td>
              <td>
              <report-header :text='report_key | decMoney'></report-header>
              </td>
            </tr>
          </template>
        </template>
      </tbody>
    </v-simple-table>
    </v-container>

    <!-- Date Picker Dialog -->
    <wc-dialog
      :showDialog='showDatePickerDialog'
      title='Change Report Period'
      icon='mdi-calendar'
      width='300'
      @save='saveDateChange'
      @cancel='showDatePickerDialog = false'
      >
      <wc-datepicker
        v-model='from_date'
        removeClearOption
        @change='changeFromDate'
      ></wc-datepicker>
      <wc-datepicker
        v-model='to_date'
        removeClearOption
      ></wc-datepicker>
    </wc-dialog>
    <account-transaction-dialog
      :showDialog='showTransactionDialog'
      :transactions='transactions'
      :title='transactionsTitle'
      :loading='loadingTransactions'
      @close='showTransactionDialog = false'
    ></account-transaction-dialog>
  </div>
</template>

<script>
import managementAPI from '@/api/management';
import accountingAPI from '@/api/accounting';
import ReportHeader from '@/modules/management/components/financial_reports/ReportHeader';
import ReportTitle from '@/modules/management/components/financial_reports/ReportTitle';
import AccountTransactionDialog from '@/modules/management/components/financial_reports/AccountTransactionDialog';
import moment from 'moment';
import miscServices from '@/services/misc';

export default {
  name: 'balance-sheet',
  data: () => ({
    isLoading: false,
    loadingTransactions: false,
    showTransactionDialog: false,
    showDatePickerDialog: false,
    transactionsTitle: '',
    accounts: [],
    transactions: [],
    from_date: null,
    to_date: null,
    new_from_date: null,
    new_to_date: null,
    reports: null
  }),
  mounted () {
    this.from_date = moment().startOf('month').format('YYYY-MM-DD').toString();
    this.to_date = moment().format('YYYY-MM-DD').toString();
    this.getData()
  },
  methods: {
    async getData() {
      this.isLoading = true;
      this.reports = await managementAPI.getProfitAndLossReport(this.from_date, this.to_date);
      this.isLoading = false;
    },
    saveDateChange () {
      this.reports = null;
      this.getData();
      this.showDatePickerDialog = false;
    },
    async lineClick (line) {
      this.showTransactionDialog = true;
      this.loadingTransactions = true;
      this.transactionsTitle = line.name + ' Transactions';
      this.transactions = await accountingAPI.getAccountTransactions(line.id, this.from_date, this.to_date);
      this.loadingTransactions = false;
    },
    flattenPLForExport (data) {
      const rows = []
      const SECTIONS = ['Revenue', 'Expense']

      SECTIONS.forEach(section => {
        rows.push([section.toUpperCase(), ''])
        data[section].forEach(group => {
          const groupName = Object.keys(group).find(k => k !== 'Group Total')
          if (groupName === 'Total Revenue' || groupName === 'Total Expenses') {
            rows.push([''])
            rows.push([groupName.toUpperCase(), group[groupName]])
            return
          }
          rows.push([groupName.toUpperCase(), ''])
          group[groupName].forEach(account => {
            rows.push([`  ${account.name}`, account.value])
          })
          rows.push([`  GROUP TOTAL`, group['Group Total']])
          rows.push([''])
        })
        rows.push([''])
      })

      rows.push(['NET INCOME', data['Net Income']])
      return rows
    },
    handleExport () {
      const rows = this.flattenPLForExport(this.reports)
      const filename = `profit-and-loss_${this.from_date}_${this.to_date}`
      miscServices.downloadAsSpreadsheet(['Account', 'Amount ($)'], rows, filename)
    },
  },
  components: {
    'report-header': ReportHeader,
    'report-title': ReportTitle,
    'account-transaction-dialog': AccountTransactionDialog
  }
}
</script>